<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCardBody>
        <CDataTable
          :items="tableData"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
          responsive
        >
          <template #icon="{ item }">
            <td>
              <img :Src="item.icon" class="icon" />
            </td>
          </template>
          <template #action="{ item }">
            <td>
              <CButton  v-if="item.userRole == 'user'"
                color="primary"
                style="width: 200px"
                @click="paidToken(item)"
                >Create Tournament</CButton
              > &nbsp;
              <CButton  v-if="item.userRole!= 'user'"
                color="primary"
                style="width: 120px"
                @click="paidToken(item)"
                >Create Paid</CButton
              > &nbsp;
              <CButton v-if="item.userRole!= 'user'"
                color="warning"
                style="width: 120px"
                @click="freeToken(item)"
                >Create Free </CButton
              >
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import firebase from "firebase";
const db = firebase.firestore();
import moment from "moment";
import Swal from "sweetalert2";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  components: {
    JsonCSV,
    DatePicker,
    VueCtkDateTimePicker,
  },
  data() {
    return {
      tableData: [],
      // userdata: [],
      tableData2: [],
      tableData3: [],
      fields: [
        {
          label: "Icon",
          key: "icon",
          sortable: true,
        },
        {
          label: "Name",
          key: "name",
          sortable: true,
        },
        // {
        //   label: "StartTime",
        //   key: "StartTime",
        //   sortable: true,
        // },

        // {
        //   label: "EndTime",
        //   key: "endTime",
        //   sortable: true,
        // },
        {
          label: "Action",
          key: "action",
          sortable: true,
        },
      ],
    };
  },
  methods: {
    paidToken(item) {
      console.log("item", item);
      this.$router.push({
        name: "paidTournament",
        params: { id: item.id, name: item.name, icon: item.icon },
      });
    },
    freeToken(item) {
      console.log("item", item);
      this.$router.push({
        name: "freeTournament",
        params: { id: item.id, name: item.name, icon: item.icon },
      });
    },
    async getGames() {
      try {
        await db
          .collection("gamesCategories")
          .where("isAndroid", "==", true)
          .where("isIos", "==", true)
          .where("fixedPayout", "==", false)
          .where("isTournament", "==", true)
          .get()
          .then((snapshot) => {
            this.tableData = [];
            var i = 0;
            var dateNow = new Date();
            snapshot.forEach((doc) => {
              // console.log("doc.data()", doc.id);
              // if (i != 0) {
              //   if (dateNow.getTime() / 1000 > doc.data().endTime.seconds) {
              this.tableData.push({
                id: doc.id,
                name: doc.data().title,
                icon: doc.data().thumbnail,
                userRole: this.user.userRole
              });
            });
            // console.log("this.tableData this.tableData", this.tableData);
          })
          .catch((e) => {
            console.log("Erorr: ", e.message);
          });
      } catch (error) {
        console.log("error", error);
      }
    },
  },
  created() {   
    this.user = JSON.parse(localStorage.getItem("data")); //push all data to this.articles
   
    this.getGames();
  },
};
</script>

<style>
.icon {
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
</style>
